import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { Panel, PanelBody, PanelHead } from '../../components/primitives/Panel';
import { campaignMessages as messages } from './campaignMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the setup; each part uses its own slice of it */
import styles from './Builder.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface QuestionPanelProps {
  title: string;
  hint?: string;
  /** "Question 1 of 2" above the title (frame b1). */
  question?: { number: number; total: number };
  right?: React.ReactNode;
  /** No padding: rows that run to the edges (the kinds of step 2). */
  flush?: boolean;
  testId?: string;
  children: React.ReactNode;
}

/** One card of a setup step (design outreach-v2 `card` + `qhead`): the question, a hint, the body. */
const QuestionPanelComponent: React.FC<QuestionPanelProps> = ({
  title,
  hint,
  question,
  right,
  flush = false,
  testId,
  children,
}) => {
  const intl = useIntl();
  return (
    <Panel as="section" data-testid={testId}>
      <PanelHead
        title={
          <>
            {question !== undefined && (
              <span className={`${styles.qnum} d-block`}>{intl.formatMessage(messages.questionOf, question)}</span>
            )}
            {title}
          </>
        }
        subtitle={hint}
        right={right}
      />
      <PanelBody stack={!flush} flush={flush}>
        {children}
      </PanelBody>
    </Panel>
  );
};

export const QuestionPanel = TypedMemo(QuestionPanelComponent);
